<div mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    <mat-icon class="w-25" style="height: 50px;" [svgIcon]="notificationIcon"></mat-icon>
</div>

<mat-divider></mat-divider>

<mat-dialog-content>
    <div class="container-fluid">
        <div class="row" [formGroup]="notificationForm">
            <mat-radio-group formControlName="type">
                <mat-radio-button value="TEXT">Receive text message</mat-radio-button>
                <mat-radio-button value="EMAIL">Receive email</mat-radio-button>
            </mat-radio-group>
            <br />

            <ng-container formArrayName="targets">
                <ng-container *ngFor = "let singleTarget of targets.controls;let i = index;">
                    <ng-container [formGroup]="singleTarget">
                        <mat-form-field appearance="outline" class="w-100 mb-3 mt-2">
                            <mat-label>Target</mat-label>
                            <mat-error>You need to enter your target</mat-error>
                            <input formControlName="target" matInput placeholder="Ex: 514-212-3123" required>
                            <button matSuffix mat-icon-button aria-label="Clear" (click)="onRemoveTarget(i)">
                                <mat-icon>close</mat-icon>
                            </button>
                            <mat-hint>Enter where would you want to receive those notifications</mat-hint>
                        </mat-form-field>
                    </ng-container>
                </ng-container>
            </ng-container>

            
            <div class="col-12 d-flex justify-content-center mb-2">
                <button type="button" mat-fab extended (click)="onAddTargets()" class="bg-light text-dark me-2 extended-fab"
                    aria-label="Example icon button with a delete icon">
                    <mat-icon>add</mat-icon>
                    Add target
                </button>
            </div>
            <app-form-entries [formEntryForm] = "notificationForm" [formEntries]="data.notification?.formEntries || []"></app-form-entries>
        </div>

    </div>
</mat-dialog-content>

<mat-divider></mat-divider>
<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button (click)="onSubmit()" class="w-25" [disabled]=" isLoading "
        color="warn">Close</button>
    <button (click)="onSubmit()" mat-raised-button class="w-25" [disabled]="!notificationForm.valid || isLoading" color="primary">
        <span *ngIf="!isLoading">
            save
        </span>
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>

</mat-dialog-actions>